/**
 * @generated SignedSource<<dec862bd6ac9b2d739298bd3e4f31373>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MATSolvedProblemUserAnswerUpdateInput = {
  currentAnswer: number;
  previousAnswer: number;
  sequence: number;
};
export type TaskSolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation$variables = {
  input: MATSolvedProblemUserAnswerUpdateInput;
};
export type TaskSolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation$data = {
  readonly solvedProblemUserAnswerUpdate: {
    readonly currentAnswerCount: number;
    readonly previousAnswerCount: number;
  };
};
export type TaskSolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation = {
  response: TaskSolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation$data;
  variables: TaskSolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MATSolvedProblemUserAnswer",
    "kind": "LinkedField",
    "name": "solvedProblemUserAnswerUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "previousAnswerCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentAnswerCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskSolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskSolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "89ad3f5c39d829f53e8922f7f228f75e",
    "id": null,
    "metadata": {},
    "name": "TaskSolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation TaskSolvedProblemUserAnswerUpdateDialog_matSolvedProblemUserAnswerUpdateMutation(\n  $input: MATSolvedProblemUserAnswerUpdateInput!\n) {\n  solvedProblemUserAnswerUpdate(input: $input) {\n    previousAnswerCount\n    currentAnswerCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "a3e18e584d102a0e9e0e1844bb3c2fc8";

export default node;
